/* Termékleírás — sections/tn-product-details.liquid · v10 · 2026-09-14
   Csak kattintásra dolgozik (nincs görgetés-, méret- vagy láthatóságfigyelő → nincs futásidejű teher).
   1) tartalomsáv-horgonyok (sima görgetés)      5) változat kiválasztása a kártyákról → buy-box
   2) videó-facade (YouTube csak kattintásra)      6) chat megnyitása
   3) részletfotó-nagyító                          7) nyitó CTA → buy-box változatlista
   4) kiegészítő kosárba tétele                    8) változatválasztó v3 (laikus / szakértői út, autó-felszereltség → egyeztetés) */
(function () {
  'use strict';
  var root = document.querySelector('[data-pd]');
  if (!root) return;

  var header = document.getElementById('shopify-section-header');
  // a fejléc csak akkor számít bele az eltolásba, ha tényleg tapad (a TOPNAVI-fejléc görgetéssel elmegy → 0)
  function headerH() {
    if (!header) return 0;
    var els = [header, header.firstElementChild];
    for (var i = 0; i < els.length; i++) {
      if (!els[i]) continue;
      var p = getComputedStyle(els[i]).position;
      if (p === 'sticky' || p === 'fixed') return els[i].offsetHeight;
    }
    return 0;
  }
  function scrollToEl(el, extra) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerH() - (extra == null ? 12 : extra);
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  /* 1) horgonyok */
  var nav = root.querySelector('[data-pd-nav]');
  if (nav) {
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      nav.removeAttribute('open');
      scrollToEl(t, 8);
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
    });
    // kattintás a gombon kívül / Esc → bezár
    document.addEventListener('click', function (e) { if (nav.open && !nav.contains(e.target)) nav.removeAttribute('open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.open) nav.removeAttribute('open'); });
  }

  /* 3) nagyító */
  var lb = root.querySelector('[data-pd-lb]');
  var lbImg = lb && lb.querySelector('[data-pd-lb-img]');
  var lbCap = lb && lb.querySelector('[data-pd-lb-cap]');
  var photos = [], cur = 0, lastFocus = null;
  function lbShow() {
    var b = photos[cur]; if (!b) return;
    var im = b.querySelector('img');
    lbImg.src = b.getAttribute('data-pd-photo');
    lbImg.alt = im ? im.alt : '';
    lbCap.textContent = (b.getAttribute('data-pd-cap') || '') + (photos.length > 1 ? ' · ' + (cur + 1) + ' / ' + photos.length : '');
    var multi = photos.length > 1;
    lb.querySelector('[data-pd-lb-prev]').hidden = !multi;
    lb.querySelector('[data-pd-lb-next]').hidden = !multi;
  }
  function lbOpen(btn) {
    if (!lb) return;
    photos = [].slice.call(root.querySelectorAll('[data-pd-photo]')).filter(function (b) { return b.offsetParent !== null; }); /* pd-brand: a rejtett rész képei kimaradnak */
    cur = Math.max(0, photos.indexOf(btn));
    lastFocus = btn;
    lbShow();
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    lb.querySelector('[data-pd-lb-close]').focus();
  }
  function lbClose() {
    lb.hidden = true;
    lbImg.removeAttribute('src');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function lbGo(d) { if (!photos.length) return; cur = (cur + d + photos.length) % photos.length; lbShow(); }
  if (lb) {
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('[data-pd-lb-close]')) lbClose();
      else if (e.target.closest('[data-pd-lb-prev]')) lbGo(-1);
      else if (e.target.closest('[data-pd-lb-next]')) lbGo(1);
    });
    var tx = 0;
    lb.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 50) lbGo(dx < 0 ? 1 : -1); }, { passive: true });
  }

  /* 4) kosárba */
  function addToCart(btn) {
    if (btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-pd-add'), 10);
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Hozzáadás…';
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      btn.textContent = '✓ Kosárban';
      btn.classList.add('is-added');
      return fetch(base + 'cart.js').then(function (r2) { return r2.json(); });
    }).then(function (c) {
      document.querySelectorAll('.turbo-cart-count, .cart-count').forEach(function (el) { el.textContent = c.item_count; el.style.display = c.item_count > 0 ? 'flex' : 'none'; });
      document.querySelectorAll('.mobile-cart-count').forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
    }).catch(function () {
      btn.textContent = 'Hiba — próbáld újra';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
    });
  }

  /* 5) változat kiválasztása → buy-box */
  function pickTier(tier) {
    var card = document.querySelector('[data-ap-variant-card][data-tier="' + tier + '"]');
    if (!card) return;
    card.click();
    scrollToEl(card.closest('.ap-buybox') || card, 16);
  }

  /* 6/b) márkás (Pioneer, Kenwood, Xtrons) kártya → a termék saját oldala
     (2026-09-23: a régi [data-tn-pio-card] buy-box kártyák 09-20 óta nem léteznek — link-kártyák lettek) */
  function pickAlt(handle) {
    var a = document.querySelector('[data-tn-alt-go="' + handle + '"]');
    window.location.href = a ? a.getAttribute('href') : '/products/' + handle;
  }

  /* 7) nyitó CTA → buy-box változatlista */
  function goBuy() {
    var card = document.querySelector('[data-ap-variant-card]');
    var box = document.querySelector('.ap-buybox');
    if (card) { scrollToEl(card, 64); return; }
    if (box) { scrollToEl(box, 16); return; }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* 6) chat: a lebegő TOPNAVI-chat indítógombja; ha 3 mp alatt sem töltött be, e-mail */
  function openChat(btn) {
    var tries = 0;
    (function attempt() {
      var launcher = document.querySelector('.tninq-b');
      if (launcher) { launcher.click(); return; }
      if (++tries < 15) { setTimeout(attempt, 200); return; }
      var mail = btn.getAttribute('data-pd-mail');
      if (mail) window.location.href = 'mailto:' + mail;
    })();
  }

  /* 8) változatválasztó v3 (2026-09-23, tulaj: „mehet az új melyiket válasszam")
        0. lépés: laikus („Segítsetek") vagy szakértői út („Tudom, mit keresek" → memória + 4G szűrő → összehasonlító).
        Laikus út: telefon → mit szeretnél a kijelzőn → hangzás → MI VAN MOST AZ AUTÓDBAN (többválasztós; ha eredeti
        navigáció / erősítős hifi / kamera / parkolóradar-kép van: „Ezt rendelés előtt egyeztessük" doboz) → [androidos
        ágon tárhely + SIM] → mi a fontosabb → [márka, ha több Pioneer/Kenwood szett van].
        A rendszert (Android vs. CarPlay/Android Auto a telefonról) fdBrandScore() dönti; a szintet a régi, bevált
        fdResolve(). A márkás alternatívák a [data-pd-fd-data] JSON „alts" tömbjéből jönnek (a régi [data-tn-pio-card]
        kártyák 2026-09-20 óta nem léteznek — emiatt volt halott a márkás ág).
        Előre semmi nincs kiemelve; a „Neked ajánlott" jelölés csak kitöltés után kerül a kapott változatra. */
  var fd = root.querySelector('[data-pd-finder]');
  var fdTiers = [], fdAlts = [], fdTitle = '';
  if (fd) {
    try {
      var fdData = JSON.parse((root.querySelector('[data-pd-fd-data]') || {}).textContent || 'null') || {};
      fdTiers = (fdData.tiers || []).filter(function (t) { return t.rank > 0; }).sort(function (x, y) { return x.rank - y.rank; });
      fdAlts = (fdData.alts || []).filter(function (a) { return a && a.h && a.avail !== false; });
      fdTitle = fdData.title || '';
    } catch (err) { fdTiers = []; fdAlts = []; }
  }
  var FD_STORE = 'tnFd4';
  try { localStorage.removeItem('tnFd3'); } catch (err) {}
  /* telefonos rendszerű gépek (Pioneer, Kenwood) és az androidos márkás gépek (Xtrons) külön */
  var fdPhoneAlts = fdAlts.filter(function (a) { return !a.android; });
  var fdAndrAlts = fdAlts.filter(function (a) { return !!a.android; });
  function fdBrandNames(list) {
    var n = []; list.forEach(function (a) { if (a.brand && n.indexOf(a.brand) === -1) n.push(a.brand); });
    return n.join(' és ');
  }
  /* „kinek szól" — egy sor szintenként (tulaj által jóváhagyott szöveg) */
  var FD_FOR = {
    standard: 'Ha a telefonodról navigálsz és zenélsz — ennél több nem kell.',
    pro: 'Mindennapi használatra; a telefon mellett pár alkalmazás is gyorsan fut a készüléken.',
    elite: 'Ha a készüléket önállóan is használnád: több alkalmazás egyszerre, offline térkép.',
    premium: 'A leggyorsabb működés, évekre előre tartalékkal.',
    premium_plus: 'Mint a PRÉMIUM, de a legtöbb tárhellyel — nagy zenetárhoz, sok offline térképhez.'
  };
  /* az autó eredeti extrái, amelyeknél a bekötést rendelés előtt egyeztetjük */
  var FD_RISK = {
    navi: ['Nagy kijelzős rádió navigációval', 'a beépített navigációs rádiók bekötése típusonként eltér'],
    amp: ['Külön erősítős hangrendszer', 'a hifi-erősítőhöz gyakran külön illesztő kell a jó hanghoz'],
    cam: ['Tolatókamera', 'a meglévő kamera átkötése típusonként eltér'],
    radar: ['Parkolóradar-kép a rádión', 'a megjelenítése típusonként eltér, illesztő kellhet hozzá']
  };
  var fdAns = {}, fdPick = null, fdAlt = null, fdNb = null, fdLast = null;

  /* Mennyire mutat a telefonos rendszerű (Pioneer/Kenwood) szett felé a kitöltés?
     Pozitív: hangzás-fejlesztés (erősítő/mélynyomó), csak a telefon képe kell, ismert telefon.
     Negatív (kizáró): videó vagy saját alkalmazások a készüléken, nincs okostelefon, SIM, nagy tárhely, ár a fő szempont. */
  function fdBrandScore() {
    var a = fdAns, s = 0;
    if (a.audio === 'amp') s += 3; else if (a.audio === 'speakers') s += 1;
    if (a.screen === 'phone') s += 1;
    if (a.phone === 'iphone' || a.phone === 'android') s += 1;
    if (a.screen === 'video' || a.screen === 'apps') s -= 10;
    if (a.phone === 'none') s -= 6;
    if (a.net) s -= 5;
    if ((a.store || 1) >= 3) s -= 3;
    if (a.prio === 'value') s -= 2;
    return s;
  }
  function fdWantsBrand() { return fdAns.mode !== 'expert' && fdPhoneAlts.length > 0 && fdBrandScore() >= 4; }
  /* A laikus válaszokból a régi, bevált szint-képlet bemenetei (use/store/prio/net). */
  function fdDerived() {
    var a = fdAns, use = 1;
    if (a.screen === 'video') use = 2;
    if (a.screen === 'apps') use = 3;
    if (a.phone === 'none') use = Math.max(use, 2);
    return { use: use, store: a.store || 1, prio: a.prio || 'balance', net: !!a.net };
  }
  function fdHas4gSplit() {
    return fdTiers.some(function (t) { return t.g4; }) && fdTiers.some(function (t) { return !t.g4; });
  }
  /* brand: a márkás (true) / androidos (false) ág kérdéssora; elhagyva a mostani válaszok döntenek */
  function fdOrder(brand) {
    if (fdAns.mode === 'expert') {
      var x = ['mode', 'xram'];
      if (fdHas4gSplit()) x.push('xnet');
      return x;
    }
    if (brand === undefined) brand = fdWantsBrand();
    var o = ['mode', 'phone', 'screen', 'audio', 'car'];
    if (!brand) o.push('store', 'net');
    o.push('prio');
    if (brand && fdPhoneAlts.length > 1) o.push('brand');
    return o;
  }
  function altInfo(a) {
    if (!a) return null;
    var nm = a.brand + (a.type ? ' ' + a.type : '');
    var ben = String(a.ben || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    return {
      brand: true, android: !!a.android, k: 'alt-' + a.h, h: a.h, url: a.url,
      name: nm + (a.android ? '' : ' szett'),
      mem: ben.slice(0, 2).join(' · ') || (a.android ? 'Android a fejegységen, alkalmazásokkal' : 'CarPlay és Android Auto a telefonodról'),
      cents: a.cents || 0, price: a.cents ? fdMoney(a.cents) : '', from: !!a.from, brandName: a.brand
    };
  }
  function altCheapest(list) {
    var best = null;
    list.forEach(function (a) { if (!best || (a.cents && a.cents < best.cents)) best = a; });
    return altInfo(best);
  }
  function altResolve() {
    if (fdAns.brand && fdAns.brand !== 'any') {
      for (var i = 0; i < fdPhoneAlts.length; i++) { if (fdPhoneAlts[i].h === fdAns.brand) return altInfo(fdPhoneAlts[i]); }
    }
    return altCheapest(fdPhoneAlts);
  }
  function fdBrandOpts() {
    var box = fd.querySelector('[data-pd-fd-brand-opts]'); if (!box) return;
    box.innerHTML = '';
    fdPhoneAlts.forEach(function (a) {
      var i = altInfo(a);
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pd-fd__opt';
      b.setAttribute('data-k', 'brand'); b.setAttribute('data-v', a.h);
      b.innerHTML = '<b></b><span></span>';
      b.querySelector('b').textContent = i.name.replace(/ szett$/, '') + (i.price ? ' · ' + i.price + (i.from ? '-tól' : '') : '');
      b.querySelector('span').textContent = i.mem;
      box.appendChild(b);
    });
    var any = document.createElement('button'); any.type = 'button'; any.className = 'pd-fd__opt';
    any.setAttribute('data-k', 'brand'); any.setAttribute('data-v', 'any');
    any.innerHTML = '<b>Mindegy, a kedvezőbb árút</b><span>A tudásuk hasonló, az ár dönt</span>';
    box.appendChild(any);
  }
  /* szakértői út: a lapon lévő memóriaméretek */
  function fdRamOpts() {
    var box = fd.querySelector('[data-pd-fd-ram-opts]'); if (!box) return;
    box.innerHTML = '';
    var rams = [];
    fdTiers.forEach(function (t) { if (t.ram && rams.indexOf(t.ram) === -1) rams.push(t.ram); });
    rams.sort(function (x, y) { return x - y; });
    rams.forEach(function (r) {
      var ts = fdTiers.filter(function (t) { return t.ram === r; });
      var min = 0; ts.forEach(function (t) { if (t.cents && (!min || t.cents < min)) min = t.cents; });
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pd-fd__opt';
      b.setAttribute('data-k', 'xram'); b.setAttribute('data-v', String(r));
      b.innerHTML = '<b></b><span></span>';
      b.querySelector('b').textContent = r + ' GB';
      b.querySelector('span').textContent = ts.map(function (t) { return t.name + ' (' + t.rom + ' GB tárhely' + (t.g4 ? ', 4G' : '') + ')'; }).join(' · ') + (min ? ' · ' + fdMoney(min) + '-tól' : '');
      box.appendChild(b);
    });
    var any = document.createElement('button'); any.type = 'button'; any.className = 'pd-fd__opt';
    any.setAttribute('data-k', 'xram'); any.setAttribute('data-v', 'any');
    any.innerHTML = '<b>Mindegy</b><span>Mutassátok a lehetőségeket</span>';
    box.appendChild(any);
  }
  function fdCarSync() {
    var sel = fdAns.car || [];
    [].forEach.call(fd.querySelectorAll('.pd-fd__opt--multi[data-k="car"]'), function (b) {
      b.setAttribute('aria-pressed', sel.indexOf(b.getAttribute('data-v')) >= 0 ? 'true' : 'false');
    });
  }

  /* 2026-09-19 (tulaj: „a topappba … a választásokról legyen logunk, hogy abból tudjunk tanulni"):
     a kitöltés lépései és a végeredmény a TopApp esemény-végpontjára mennek sendBeacon-nal —
     véletlen munkamenet-azonosító, süti és személyes adat nélkül, ugyanúgy, mint a kiegészítő-popupnál. */
  var FD_API = 'https://app.topnavi.hu/accessory/event';
  var fdSid = '';
  try { var _a = new Uint8Array(12); crypto.getRandomValues(_a); _a.forEach(function (x) { fdSid += ('0' + x.toString(16)).slice(-2); }); }
  catch (e) { fdSid = (Date.now().toString(16) + Math.random().toString(16).slice(2)).slice(0, 24); }
  var fdPid = (function () {
    var el = document.getElementById('tn-acc-data');
    try { return el ? (JSON.parse(el.textContent) || {}).pid : null; } catch (err) { return null; }
  })();
  function fdLog(name, data) {
    try {
      var ev = { event: 'finder_' + name, pp: fdPid || null, ans: fdAns, t: Date.now() };
      if (data) for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) ev[k] = data[k];
      var body = JSON.stringify({ sid: fdSid, src: 'finder', events: [ev] });
      if (navigator.sendBeacon) navigator.sendBeacon(FD_API, new Blob([body], { type: 'text/plain' }));
    } catch (err) {}
  }

  function fdTarget(a) {
    var base = Math.max(a.use || 1, a.store || 1);
    if (a.prio === 'balance') return Math.max(base, 2);
    if (a.prio === 'best') return Math.min(5, Math.max(base + 1, 3));
    return base;
  }
  function fdResolve(a) {
    if (!fdTiers.length || !a || typeof a.use !== 'number' || typeof a.store !== 'number' || !a.prio) return null;
    var t = fdTarget(a), pick = null, best = 99;
    fdTiers.forEach(function (x) {
      var d = Math.abs(x.rank - t) + (x.rank < t ? 0.5 : 0);   // döntetlennél az erősebb, ha az igényt nem fedi a gyengébb
      if (d < best) { best = d; pick = x; }
    });
    if (a.net && pick && !pick.g4) {
      for (var i = 0; i < fdTiers.length; i++) { if (fdTiers[i].g4 && fdTiers[i].rank >= pick.rank) { pick = fdTiers[i]; break; } }
    }
    return pick;
  }
  /* szakértői szűrés: a feltételeknek megfelelő változatok, olcsótól drágáig */
  function fdExpertPick() {
    var ram = fdAns.xram || 0, xn = fdAns.xnet || 'any';
    function ok4g(t) { return xn !== 'need' || t.g4; }
    var m = fdTiers.filter(function (t) { return (!ram || t.ram === ram) && ok4g(t); });
    if (!m.length) m = fdTiers.filter(function (t) { return (!ram || t.ram >= ram) && ok4g(t); });
    if (!m.length) m = fdTiers.slice();
    if (xn === 'no') {
      var n4 = m.filter(function (t) { return !t.g4; });
      if (n4.length) m = n4.concat(m.filter(function (t) { return t.g4; }));
    }
    var picks = m.slice(0, 3);
    if (picks.length < 2) {
      var p0 = picks[0];
      var nb = fdTiers.filter(function (t) { return t.rank > p0.rank; })[0] || fdTiers.filter(function (t) { return t.rank < p0.rank; }).pop();
      if (nb) picks.push(nb);
    }
    return { primary: m[0], picks: picks, exact: m.length };
  }
  function fdMoney(c) { return String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft'; }
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2.5 2.9 5.9 6.5.9-4.7 4.6 1.1 6.4L12 17.3l-5.8 3 1.1-6.4-4.7-4.6 6.5-.9L12 2.5Z"/></svg>';
  var REC = '<svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden="true"><path d="M12 1l3.09 6.26L22 8.27l-5 4.87 1.18 6.88L12 16.77l-6.18 3.25L7 13.14 2 8.27l6.91-1.01L12 1z"/></svg>';
  /* „Neked ajánlott": k = változat-kulcs (pl. 'pro') vagy márkás egység ('alt-<handle>') */
  function fdMark(k) {
    [].forEach.call(root.querySelectorAll('[data-pd-tc]'), function (c) {
      var on = c.getAttribute('data-pd-tc') === k;
      c.classList.toggle('is-rec', on);
      var old = c.querySelector('[data-pd-rec-flag]'); if (old) old.parentNode.removeChild(old);
      var soft = c.querySelector('.pd-tc__flag--soft'); if (soft) soft.hidden = on;
      if (on) {
        var f = document.createElement('span');
        f.className = 'pd-tc__flag pd-tc__flag--rec'; f.setAttribute('data-pd-rec-flag', '');
        f.innerHTML = STAR + 'Neked ajánljuk';
        c.insertBefore(f, c.firstChild);
      }
      var b = c.querySelector('[data-pd-pick]');
      if (b) { b.classList.toggle('pd-btn--dark', on); b.classList.toggle('pd-btn--ghost', !on); }
    });
    function badge(card, on) {
      var old = card.querySelector('[data-fd-rec]'); if (old) old.parentNode.removeChild(old);
      if (!on) return;
      var row = card.querySelector('.apv-card-title-row'); if (!row) return;
      var s = document.createElement('span');
      s.className = 'apv-badge apv-badge--recommended'; s.setAttribute('data-fd-rec', '');
      s.innerHTML = REC + 'NEKED AJÁNLOTT';
      row.appendChild(s);
    }
    [].forEach.call(document.querySelectorAll('[data-ap-variant-card]'), function (card) { badge(card, !!k && card.getAttribute('data-tier') === k); });
    [].forEach.call(document.querySelectorAll('[data-tn-alt-go]'), function (card) { badge(card, !!k && k === 'alt-' + card.getAttribute('data-tn-alt-go')); });
  }
  /* 2026-09-23 — a haladás sosem lép vissza. Az út hossza menet közben változik (a márkás ágon nincs tárhely-
     és SIM-kérdés, de lehet márka-kérdés; visszalépés + másik válasz után újra hosszabb lehet), ezért korábban
     „3 / 7" után „4 / 6", visszalépés után „4 / 6" → „4 / 7" és hátráló sáv is előfordult. Most:
     – a nevező a mód LEGHOSSZABB lehetséges útja (laikus: 7), egy kitöltésen belül sosem változik; a számláló a
       kérdés valódi sorszáma, az aktuális út utolsó kérdésén „Utolsó kérdés" (a rövidebb, márkás ág így nem a
       „6 / 7"-nél ér véget);
     – a sáv a valódi hátralévő útból számol, de csak nőhet (fdBar = max). Visszalépéskor is marad, mert a
       válaszok megmaradnak; nullázás csak ott, ahol a válaszok is törlődnek (megnyitás, újrakezdés, módválasztás). */
  var fdBar = 0;
  /* 2026-09-23: dupla kattintás-védelem — lépésváltás után 300 ms-ig nem fogadunk választ (a 2. kattintás a következő kérdés azonos helyű gombjára esett, és magától válaszolt) */
  var fdStepAt = 0;
  function fdMaxSteps() { return Math.max(fdOrder(false).length, fdOrder(true).length) - 1; }  /* a 0. (mód-) lépés nélkül */
  function fdStep(name) {
    fdStepAt = Date.now();
    if (name === 'brand') fdBrandOpts();
    if (name === 'xram') fdRamOpts();
    if (name === 'car') fdCarSync();
    [].forEach.call(fd.querySelectorAll('[data-pd-fd-step]'), function (s) { s.hidden = s.getAttribute('data-pd-fd-step') !== name; });
    fd.querySelector('[data-pd-fd-res]').hidden = name !== 'res';
    var order = fdOrder();
    var last = order.length - 1;                        /* a mostani út utolsó kérdésének sorszáma */
    var idx = name === 'res' ? order.length : order.indexOf(name);
    fd.querySelector('[data-pd-fd-back]').hidden = idx <= 0 || name === 'res';
    fdBar = Math.max(fdBar, name === 'res' ? 100 : Math.max(0, Math.round(((idx - 1) / Math.max(1, last)) * 100)));
    fd.querySelector('[data-pd-fd-bar]').style.width = fdBar + '%';
    var num = fd.querySelector('[data-pd-fd-step="' + name + '"] .pd-fd__q span');
    if (num) num.textContent = idx > 1 && idx === last ? 'Utolsó kérdés' : idx + ' / ' + fdMaxSteps();
    var first = fd.querySelector(name === 'res' ? '[data-pd-fd-pick]' : '[data-pd-fd-step="' + name + '"] .pd-fd__opt');
    if (first) first.focus({ preventScroll: true });
    var box = fd.querySelector('.pd-fd__box'); if (box) box.scrollTop = 0;
  }
  function fdDiff(a, b) { var d = a - b; return (d >= 0 ? '+' : '−') + fdMoney(Math.abs(d)); }
  function fdNext(key) {
    var order = fdOrder();
    var next = order[order.indexOf(key) + 1];
    if (next) fdStep(next);
    else if (fdAns.mode === 'expert') fdExpert();
    else fdShow();
  }
  /* a következő szint különbsége egy sorban: „ELITE: +2 GB memória, 4G SIM-hely, QLED · +35 000 Ft" */
  function fdNeighbor(p) {
    var nx = null;
    for (var i = 0; i < fdTiers.length; i++) { if (fdTiers[i].rank > p.rank) { nx = fdTiers[i]; break; } }
    if (!nx || !nx.cents || !p.cents || nx.cents <= p.cents) return null;
    var parts = [];
    if (nx.ram > p.ram) parts.push('+' + (nx.ram - p.ram) + ' GB memória');
    if (nx.rom > p.rom) parts.push('+' + (nx.rom - p.rom) + ' GB tárhely');
    if (nx.g4 && !p.g4) parts.push('4G SIM-hely');
    if (nx.panel === 'QLED' && p.panel !== 'QLED') parts.push('QLED kijelző');
    if (!parts.length) parts.push('gyorsabb működés');
    return { t: nx, txt: parts.join(', '), diff: '+' + fdMoney(nx.cents - p.cents) };
  }
  function fdCompat() {
    var sel = fdAns.car || [];
    var risks = sel.filter(function (r) { return FD_RISK[r]; });
    var box = fd.querySelector('[data-pd-fd-compat]');
    var swc = fd.querySelector('[data-pd-fd-swc]');
    if (swc) swc.hidden = sel.indexOf('swc') === -1;
    if (!box) return risks;
    box.hidden = !risks.length;
    var ul = box.querySelector('[data-pd-fd-compat-list]');
    if (ul) {
      ul.innerHTML = '';
      risks.forEach(function (r) {
        var li = document.createElement('li');
        var b = document.createElement('b'); b.textContent = FD_RISK[r][0];
        li.appendChild(b); li.appendChild(document.createTextNode(' – ' + FD_RISK[r][1] + '.'));
        ul.appendChild(li);
      });
    }
    var mail = box.querySelector('[data-pd-fd-mail]');
    if (mail) {
      var labels = risks.map(function (r) { return FD_RISK[r][0]; });
      if (sel.indexOf('swc') >= 0) labels.push('Kormánygombok');
      mail.href = 'mailto:info@topnavi.hu?subject=' + encodeURIComponent('Beépítés egyeztetése – ' + (fdTitle || document.title)) +
        '&body=' + encodeURIComponent('Szia!\n\nEzt a terméket néztem: ' + (fdTitle || document.title) + '\nAz autómban van: ' + labels.join(', ') +
        '\n\nAz autó típusa és évjárata: \n\n(Ha tudsz, csatolj egy fotót a mostani rádióról.)\n');
    }
    return risks;
  }
  function fdShow() {
    var d = fdDerived();
    var p = fdResolve(d);                          /* androidos változat (fő ajánlás vagy a márkás ajánlás párja) */
    var bp = fdWantsBrand() ? altResolve() : null; /* CarPlay/Android Auto a telefonról: Pioneer / Kenwood szett */
    if (!p && !bp) return;
    var primary = bp || p;
    fdPick = primary;
    fd.querySelector('[data-pd-fd-name]').textContent = primary.name;
    fd.querySelector('[data-pd-fd-mem]').textContent = primary.mem;
    fd.querySelector('[data-pd-fd-price]').textContent = primary.price ? primary.price + (primary.from ? '-tól' : '') : '';
    var forEl = fd.querySelector('[data-pd-fd-for]');
    if (forEl) forEl.textContent = bp ? 'Ha a telefonod képét szeretnéd nagyban, gyors indulással, és fontos a hangzás — saját alkalmazások nélkül.' : (FD_FOR[p.k] || '');

    var why = [];
    var ph = fdAns.phone === 'iphone' ? 'CarPlay' : fdAns.phone === 'android' ? 'Android Auto' : 'CarPlay és Android Auto';
    if (bp) {
      if (fdAns.audio === 'amp' || fdAns.audio === 'speakers') why.push('Javítanál a hangzáson: részletesebb a hangszínszabályzó, és erősítő, mélynyomó is köthető rá.');
      why.push('A telefonod térképe és zenéje jelenik meg a kijelzőn (' + ph + '): a készüléken nincs mit beállítani, gyorsan indul.');
      why.push('A szett az autóra szabott beépítőkerettel és a szabványos csatlakozókkal érkezik — az eredeti rádió helyére kerül.');
    } else {
      if (fdAns.phone === 'none') why.push('Okostelefon nélkül a készülék saját térképe és rádiója dolgozik — ehhez ez a szint kényelmes.');
      else if (fdAns.screen === 'apps') why.push('Saját alkalmazásokat és térképet szeretnél a készüléken: nem a legkisebb memóriát ajánljuk, így évek múlva is gyors marad.');
      else if (fdAns.screen === 'video') why.push('Álló helyzetben videózáshoz ez a szint már gördülékeny.');
      else if (fdAns.screen === 'phone') why.push('A térkép és a zene a telefonodról jön (' + ph + '), vezeték nélkül is.');
      if (fdAns.net) why.push(p.g4 ? 'Saját SIM-kártyával telefon nélkül is online a készülék.' : 'Ennél a változatnál nincs SIM-hely, az internetet a telefonod adja.');
      if ((fdAns.store || 1) >= 3 && p.rom >= 128) why.push(p.rom + ' GB tárhely: elfér benne sok zene és offline térkép.');
      if (fdAns.prio === 'value') why.push('A válaszaid alapján ennél erősebbre nincs szükséged.');
      else if (fdAns.prio === 'best') why.push('Több tartalék: évekig gyors marad.');
      else why.push('Jó középút: gyors, kényelmes működés, felesleges extrák nélkül.');
      if (fdAns.audio === 'amp' && fdPhoneAlts.length) why.push('Erősítőt tervezel: a hangzásban a ' + fdBrandNames(fdPhoneAlts) + ' erősebb — lent megnézheted az alternatívát.');
      if (!why.length) why.push('Kiegyensúlyozott választás: gyors működés, ésszerű áron.');
    }
    var ul = fd.querySelector('[data-pd-fd-why]'); ul.innerHTML = '';
    why.slice(0, 3).forEach(function (w) { var li = document.createElement('li'); li.textContent = w; ul.appendChild(li); });

    var risks = fdCompat();
    var pickBtn = fd.querySelector('[data-pd-fd-pick]');
    if (pickBtn) pickBtn.textContent = bp ? 'Megnézem' : 'Ezt választom';

    /* szomszéd-sor: a következő szint (csak androidos ajánlásnál) */
    var nbBtn = fd.querySelector('[data-pd-fd-nb]');
    fdNb = null; nbBtn.hidden = true;
    if (!bp && p) {
      var nb = fdNeighbor(p);
      if (nb) {
        fdNb = nb.t;
        nbBtn.innerHTML = '<span><b></b> <span></span></span><span class="pd-fd__nb-p"></span>';
        nbBtn.querySelector('b').textContent = nb.t.name + ':';
        nbBtn.querySelector('span span').textContent = nb.txt;
        nbBtn.querySelector('.pd-fd__nb-p').textContent = nb.diff;
        nbBtn.setAttribute('aria-label', 'Egy szinttel feljebb: ' + nb.t.name + ', ' + nb.txt + ', ' + nb.diff);
        nbBtn.hidden = false;
      }
    }

    /* alternatíva a MÁSIK rendszerből */
    var altBtn = fd.querySelector('[data-pd-fd-alt]');
    fdAlt = null; altBtn.hidden = true;
    if (bp) {
      if (p && p.cents > 0) { fdAlt = p; altBtn.textContent = 'Android a fejegységen, alkalmazásokkal: ' + p.name + ' (' + fdDiff(p.cents, bp.cents) + ')'; }
    } else if (p) {
      if (fdAndrAlts.length && (fdAns.screen === 'apps' || fdAns.net) && fdAns.prio === 'best') {
        var xa = altCheapest(fdAndrAlts);
        if (xa && xa.cents) { fdAlt = xa; altBtn.textContent = 'Android a fejegységen, más gyártótól: ' + xa.name + ' (' + fdDiff(xa.cents, p.cents) + ')'; }
      } else if (fdPhoneAlts.length && fdAns.screen !== 'apps' && fdAns.screen !== 'video' && fdAns.phone !== 'none' && fdBrandScore() >= 0) {
        var ba = altResolve();
        if (ba && ba.cents && p.cents > 0) { fdAlt = ba; altBtn.textContent = 'CarPlay és Android Auto a telefonodról: ' + ba.name + ' (' + fdDiff(ba.cents, p.cents) + ')'; }
      }
    }
    altBtn.hidden = !fdAlt;

    try { localStorage.setItem(FD_STORE, JSON.stringify(fdAns)); } catch (err) {}
    fdMark(primary.k);
    if (bp) { var ab = document.querySelector('[data-tn-alt]'); if (ab) ab.open = true; }
    fdLog('result', { out: bp ? 'brand:' + bp.h : 'tier:' + p.k, score: fdBrandScore(), car: (fdAns.car || []).join('+') || 'none', compat: risks.length > 0 });
    fdStep('res');
  }
  /* szakértői út vége: jelölés + az összehasonlító megnyitása a megfelelő változatokkal */
  function fdOpenCompare(keys) {
    if (!root.querySelector('[data-tn-cmp-data]')) return false;
    var btns = keys.map(function (k) { return root.querySelector('[data-tn-cmp-add="tier:' + k + '"]'); });
    if (btns.length < 2 || btns.some(function (b) { return !b; })) return false;
    var go = document.querySelector('[data-tn-cmp-open]'); if (!go) return false;
    var clr = document.querySelector('[data-tn-cbar-clear]'); if (clr) clr.click();
    btns.forEach(function (b) { b.click(); });
    go.click();
    return true;
  }
  function fdExpert() {
    var r = fdExpertPick();
    if (!r.primary) return;
    try { localStorage.setItem(FD_STORE, JSON.stringify(fdAns)); } catch (err) {}
    fdMark(r.primary.k);
    fdLog('result', { out: 'tier:' + r.primary.k, mode: 'expert', picks: r.picks.map(function (t) { return t.k; }).join('+') });
    fdClose();
    if (!fdOpenCompare(r.picks.map(function (t) { return t.k; }))) pickTier(r.primary.k);
  }
  /* 2026-09-19: a görgetés-zár nem ragadhat bent — az előző értéket adjuk vissza, és
     oldalelhagyáskor / visszalépéskor biztosan feloldjuk. */
  var fdOverflowPrev = null;
  function fdOpen(trigger) {
    if (!fd || !fdTiers.length) return false;
    fdAns = {}; fdBar = 0; fdLast = trigger || document.activeElement;
    fd.hidden = false;
    if (fdOverflowPrev === null) fdOverflowPrev = document.documentElement.style.overflow || '';
    document.documentElement.style.overflow = 'hidden';
    fdStep('mode');
    fdLog('open', null);
    return true;
  }
  function fdClose() {
    if (!fd || fd.hidden) return;
    fd.hidden = true;
    document.documentElement.style.overflow = fdOverflowPrev || '';
    fdOverflowPrev = null;
    if (fdLast && fdLast.focus) fdLast.focus({ preventScroll: true });
  }
  function fdGo(x) {
    if (!x) return;
    if (x.brand) { window.location.href = x.url || ('/products/' + x.h); return; }
    pickTier(x.k);
  }
  window.addEventListener('pagehide', function () { if (fd && !fd.hidden) fdClose(); });
  window.addEventListener('pageshow', function () {
    if (fd && fd.hidden && document.documentElement.style.overflow === 'hidden') {
      document.documentElement.style.overflow = fdOverflowPrev || '';
      fdOverflowPrev = null;
    }
  });
  if (fd && fdTiers.length) {
    fd.addEventListener('click', function (e) {
      if (e.target === fd || e.target.closest('[data-pd-fd-close]')) { fdClose(); return; }
      var opt = e.target.closest('.pd-fd__opt');
      if ((opt || e.target.closest('[data-pd-fd-next]')) && (e.detail > 1 || Date.now() - fdStepAt < 300)) return;
      if (opt) {
        var key = opt.getAttribute('data-k'), val = opt.getAttribute('data-v');
        if (key === 'car') {
          if (val === 'none') { fdAns.car = []; fdCarSync(); fdLog('step', { k: 'car', v: 'none' }); fdNext('car'); return; }
          var sel = (fdAns.car || []).slice(), at = sel.indexOf(val);
          if (at >= 0) sel.splice(at, 1); else sel.push(val);
          fdAns.car = sel; fdCarSync();
          return;
        }
        if (key === 'mode') { fdAns = { mode: val }; fdBar = 0; }                   /* módváltáskor tiszta lap */
        else if (key === 'store') fdAns.store = val === 'dk' ? null : parseInt(val, 10);
        else if (key === 'net') fdAns.net = (val === '1');                           /* „nem tudom" = nem kér SIM-et */
        else if (key === 'prio') fdAns.prio = val === 'dk' ? 'balance' : val;        /* „nem tudom" = egyensúly */
        else if (key === 'xram') fdAns.xram = val === 'any' ? null : parseInt(val, 10);
        else if (val === 'dk') fdAns[key] = null;                                    /* „nem tudom" — nem torzítja a pontszámot */
        else fdAns[key] = val;
        fdLog('step', { k: key, v: val });
        fdNext(key);
        return;
      }
      if (e.target.closest('[data-pd-fd-next]')) { fdLog('step', { k: 'car', v: (fdAns.car || []).join('+') || 'none' }); fdNext('car'); return; }
      if (e.target.closest('[data-pd-fd-back]')) {
        var curStep = fd.querySelector('[data-pd-fd-step]:not([hidden])');
        var order = fdOrder();
        var idx = curStep ? order.indexOf(curStep.getAttribute('data-pd-fd-step')) : 0;
        if (idx > 0) fdStep(order[idx - 1]);
        return;
      }
      if (e.target.closest('[data-pd-fd-again]')) { fdAns = {}; fdBar = 0; fdStep('mode'); return; }
      if (e.target.closest('[data-pd-fd-chat]')) { fdLog('compat_chat', null); var cb = e.target.closest('[data-pd-fd-chat]'); fdClose(); openChat(cb); return; }
      if (e.target.closest('[data-pd-fd-mail]')) { fdLog('compat_mail', null); return; }
      if (e.target.closest('[data-pd-fd-nb]') && fdNb) { var n = fdNb; fdLog('pick_nb', { out: 'tier:' + n.k }); fdClose(); pickTier(n.k); return; }
      if (e.target.closest('[data-pd-fd-alt]') && fdAlt) { var alt = fdAlt; fdLog('pick_alt', { out: alt.brand ? 'brand:' + alt.h : 'tier:' + alt.k }); fdClose(); fdGo(alt); return; }
      if (e.target.closest('[data-pd-fd-pick]') && fdPick) { var pk = fdPick; fdLog('pick', { out: pk.brand ? 'brand:' + pk.h : 'tier:' + pk.k }); fdClose(); fdGo(pk); }
    });
    // korábbi kitöltés → a jelölés ennél a terméknél is (a termék saját változataiból számolva)
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(FD_STORE) || 'null'); } catch (err) { saved = null; }
    if (saved && saved.mode) {
      var keep = fdAns; fdAns = saved;
      if (saved.mode === 'expert') { var sx = fdExpertPick(); if (sx.primary) fdMark(sx.primary.k); }
      else if (fdWantsBrand()) { var sb = altResolve(); if (sb) fdMark(sb.k); }
      else { var sp = fdResolve(fdDerived()); if (sp) fdMark(sp.k); }
      fdAns = keep;
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (lb && !lb.hidden) lbClose(); else fdClose(); return; }
    if (lb && !lb.hidden) { if (e.key === 'ArrowLeft') lbGo(-1); else if (e.key === 'ArrowRight') lbGo(1); }
    /* 2026-09-23 (a11y-4): fókuszcsapda a „Melyiket válasszam?" ablakban — a lista minden Tabnál újraszámolva,
       mert a lépések, a Vissza gomb és az eredményblokk rejtettsége változik. inert NEM kell (az öröklődne). */
    if (e.key === 'Tab' && fd && !fd.hidden && !(lb && !lb.hidden)) {
      var ff = [].filter.call(fd.querySelectorAll('button, a[href], summary, input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) { return !el.disabled && el.getClientRects().length; });
      if (ff.length) {
        var f1 = ff[0], fN = ff[ff.length - 1], ae = document.activeElement;
        if (e.shiftKey && (ae === f1 || !fd.contains(ae))) { e.preventDefault(); fN.focus(); }
        else if (!e.shiftKey && (ae === fN || !fd.contains(ae))) { e.preventDefault(); f1.focus(); }
      }
    }
  });

  // buy-box „Melyiket válasszam?" (a .pd-n kívül van)
  document.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('[data-apv-help]');
    if (!h) return;
    e.preventDefault();
    if (fdOpen(h)) return;
    var t = document.getElementById('pd-specifikacio');
    if (t) scrollToEl(t);
  });
  /* 2026-09-23 (a11y-12): ahol a „Melyiket válasszam?" a választó-ablakot nyitja (van rangsorolt szint → fdOpen),
     gomb-szemantika + aria-haspopup; Space is nyit (a Entert az <a> natívan kattintássá alakítja).
     Ahol nincs választó, marad sima horgony-link a #pd-specifikacio-ra. A buy box nem renderelődik újra → egyszer elég. */
  if (fd && fdTiers.length) {
    [].forEach.call(document.querySelectorAll('[data-apv-help]'), function (h) {
      h.setAttribute('role', 'button');
      h.setAttribute('aria-haspopup', 'dialog');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') return;
      var h = e.target.closest && e.target.closest('[data-apv-help][role="button"]');
      if (!h) return;
      e.preventDefault();
      fdOpen(h);
    });
  }

  /* 2) kattintás-delegálás a leírásban */
  root.addEventListener('click', function (e) {
    var o = e.target.closest('[data-pd-fd-open]');
    if (o) { if (fdOpen(o)) e.preventDefault(); return; }
    var v = e.target.closest('[data-pd-video]');
    if (v) {
      var id = v.getAttribute('data-pd-video');
      if (!/^[\w-]{6,20}$/.test(id)) return;
      var box = document.createElement('div');
      box.className = 'pd-video__frame';
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
      f.title = v.getAttribute('data-pd-video-title') || 'Bemutató videó';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.setAttribute('allowfullscreen', '');
      box.appendChild(f);
      v.parentNode.replaceChild(box, v);
      return;
    }
    var photo = e.target.closest('[data-pd-photo]');
    if (photo) { lbOpen(photo); return; }
    var add = e.target.closest('[data-pd-add]');
    if (add) { addToCart(add); return; }
    if (e.target.closest('[data-pd-buy]')) { goBuy(); return; }
    var chat = e.target.closest('[data-pd-chat]');
    if (chat) { openChat(chat); return; }
    var pickA = e.target.closest('[data-pd-pick-alt]');
    if (pickA) { pickAlt(pickA.getAttribute('data-pd-pick-alt')); return; }
    var pick = e.target.closest('[data-pd-pick]');
    if (pick) { pickTier(pick.getAttribute('data-pd-pick')); }
  });

  // ── előtte/utána csúszka v2d (2026-09-17) — lassú, finom ide-oda animáció, amíg látszik; egérrel fölé érve megáll,
  //    elhagyva 0,7 s után folytatja; húzni lenyomott gombbal / ujjal (pointer capture, touch-action: pan-y → a függőleges
  //    görgetés marad); elengedés vagy billentyű után 2,5 s-mal a jelenlegi helyről átúszva indul újra. Rejtett fülön nem fut.
  //    A kép compositor-transformmal mozog (nincs újrarajzolás), az „előtte” kép beúszik, ha később tölt be.
  document.querySelectorAll('[data-pd-vs]').forEach(function (box) {
    var range = box.querySelector('.pd-vs2__range');
    var frame = box.querySelector('.pd-vs2__frame');
    if (!range || !frame) return;
    var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var PERIOD = 4200, AMP = 11, BLEND = 900, RESUME_RELEASE = 2500, RESUME_LEAVE = 700;
    var cur = 50, dragging = false, hovered = false, visible = !('IntersectionObserver' in window);
    var anim = 0, phase = 0, lastT = 0, blendFrom = 50, blendT0 = 0, resumeTimer = 0;
    var oldImg = frame.querySelector('.pd-vs2__old img');
    if (oldImg) {
      var shown = function () { oldImg.classList.add('is-loaded'); };
      if (oldImg.complete && oldImg.naturalWidth) shown(); else oldImg.addEventListener('load', shown, { once: true });
    }
    function set(v) { cur = Math.max(0, Math.min(100, v)); range.value = String(Math.round(cur)); frame.style.setProperty('--x', cur.toFixed(2) + '%'); }
    function pos(e) { var r = frame.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; }
    function tick(now) {
      anim = 0;
      if (!visible || hovered || dragging || document.hidden) { lastT = 0; return; }
      if (lastT) phase += now - lastT;
      lastT = now;
      var target = 50 + AMP * Math.sin(phase / PERIOD * Math.PI * 2);
      var k = Math.min(1, (now - blendT0) / BLEND);
      k = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      set(blendFrom + (target - blendFrom) * k);
      anim = requestAnimationFrame(tick);
    }
    function play() {
      clearTimeout(resumeTimer); resumeTimer = 0;
      if (reduced || anim || !visible || hovered || dragging || document.hidden) return;
      blendFrom = cur; blendT0 = performance.now(); lastT = 0;
      frame.classList.add('is-live');
      anim = requestAnimationFrame(tick);
    }
    function stop() {
      if (anim) { cancelAnimationFrame(anim); anim = 0; }
      lastT = 0; clearTimeout(resumeTimer); resumeTimer = 0;
      frame.classList.remove('is-live');
    }
    function later(ms) { clearTimeout(resumeTimer); resumeTimer = setTimeout(play, ms); }
    frame.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovered = true; stop(); } });
    frame.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovered = false; if (!dragging) later(RESUME_LEAVE); } });
    frame.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      stop(); dragging = true; frame.classList.add('is-live');
      try { frame.setPointerCapture(e.pointerId); } catch (err) {}
      set(pos(e)); e.preventDefault();
    });
    frame.addEventListener('pointermove', function (e) { if (dragging) set(pos(e)); });
    function end() { if (!dragging) return; dragging = false; frame.classList.remove('is-live'); later(RESUME_RELEASE); }
    frame.addEventListener('pointerup', end);
    frame.addEventListener('pointercancel', end);
    range.addEventListener('input', function () { stop(); set(+range.value); later(RESUME_RELEASE); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else later(300); });
    set(50);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) play(); else stop(); }, { threshold: 0.35 }).observe(frame);
    } else {
      play();
    }
  });
  // ── pd-stats belépő animáció (2026-09-17): csak akkor jelöljük animálhatónak, ha a sáv még a hajtás alatt van
  //    (így az első festéskor sosem tűnik el semmi), és a láthatóvá váláskor egyszer beúszik.
  //    2026-09-25 (sebesség): a getBoundingClientRect helyett az IO első jelzése dönt (nincs kényszerített elrendezés).
  document.querySelectorAll('.pd-stats').forEach(function (el) {
    if (!('IntersectionObserver' in window)) return;
    var first = true;
    var io = new IntersectionObserver(function (en) {
      var e = en[en.length - 1];
      if (first) { first = false; if (e.isIntersecting) { io.disconnect(); return; } el.classList.add('js-anim'); return; }
      if (e.intersectionRatio >= 0.25) { el.classList.add('is-in'); io.disconnect(); }
    }, { threshold: [0, 0.25] });
    io.observe(el);
  });
})();

/* box-v6 (2026-09-18): csoportonkénti darabszám a „Csomag tartalma" fejlécekbe (CSS: data-n) */
(function(){var g=document.querySelectorAll('.pd-box__group');for(var i=0;i<g.length;i++){var t=g[i].querySelector('.pd-box__gt'),n=g[i].querySelectorAll('.pd-bi').length;if(t&&n)t.setAttribute('data-n',String(n));}})();

/* acc-v2 (2026-09-18): kiegészítő-rács — rendezés (Ajánlott / Ár), „További kiegészítők" +8 */
(function () {
  var list = document.querySelector('[data-pd-acc]'); if (!list) return;
  var shown = 8, more = document.querySelector('[data-pd-acc-more]'), rest = document.querySelector('[data-pd-acc-rest]');
  function cards() { return Array.prototype.slice.call(list.querySelectorAll('.pd-acc__card')); }
  function apply() {
    var cs = cards(); cs.forEach(function (c, i) { c.classList.toggle('is-hidden', i >= shown); });
    var left = Math.max(0, cs.length - shown);
    if (more) { more.hidden = left <= 0; if (rest) rest.textContent = left ? '(+' + left + ')' : ''; }
  }
  function sort(mode) {
    var cs = cards();
    cs.sort(function (a, b) {
      var pa = +a.getAttribute('data-price'), pb = +b.getAttribute('data-price'), oa = +a.getAttribute('data-order'), ob = +b.getAttribute('data-order');
      if (mode === 'price-asc') return (pa - pb) || (oa - ob);
      if (mode === 'price-desc') return (pb - pa) || (oa - ob);
      return oa - ob;
    });
    cs.forEach(function (c) { list.appendChild(c); });
    apply();
  }
  document.querySelectorAll('[data-pd-acc-sort]').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('[data-pd-acc-sort]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      sort(b.getAttribute('data-pd-acc-sort'));
    });
  });
  if (more) more.addEventListener('click', function () { shown += 8; apply(); });
  apply();
})();
